"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statusSelector = exports.sipSelector = exports.getSIPAccountPrefix = exports.getSIPAccountId = exports.getSIPAccount = void 0;
var sipSelector = state => state.sip;
exports.sipSelector = sipSelector;
var getSIPAccount = state => {
  var _sipSelector;
  return (_sipSelector = sipSelector(state)) === null || _sipSelector === void 0 ? void 0 : _sipSelector.SIPAccount;
};
exports.getSIPAccount = getSIPAccount;
var getSIPAccountId = state => {
  var _getSIPAccount;
  return (_getSIPAccount = getSIPAccount(state)) === null || _getSIPAccount === void 0 ? void 0 : _getSIPAccount.id;
};
exports.getSIPAccountId = getSIPAccountId;
var getSIPAccountPrefix = state => {
  var _getSIPAccount2;
  return (_getSIPAccount2 = getSIPAccount(state)) === null || _getSIPAccount2 === void 0 ? void 0 : _getSIPAccount2.prefix;
};
exports.getSIPAccountPrefix = getSIPAccountPrefix;
var statusSelector = state => {
  var _sipSelector2;
  return (_sipSelector2 = sipSelector(state)) === null || _sipSelector2 === void 0 ? void 0 : _sipSelector2.status;
};
exports.statusSelector = statusSelector;